export const ProvidersModuleTranslations: Array<string> = [
  // SAP Integrations
  'xmlSAPIntegrations',
  'Admin.SAPIntegrations.General',
  'Admin.SAPIntegrations.MandatorySettings',
  'Admin.SAPIntegrations.BackEnd',
  'Admin.SAPIntegrations.ERPProvider',
  'Admin.SAPIntegrations.CPSProvider',
  'Admin.SAPIntegrations.GeneralAttributeMappings',
  'Admin.SAPIntegrations.BRIMProvider',
  'Admin.SAPIntegrations.SBProvider',
  'Admin.SAPIntegrations.FrontEnd',
  'Admin.SAPIntegrations.C4C',
  'Admin.SAPIntegrations.C4CObsolete',
  'Admin.SAPIntegrations.SAPCommerce',
  'Admin.SAPIntegrations.AI',
  'Admin.SAPIntegrations.CXAIProvider',
  'Admin.ThirdPartyIntegrations.ExteralConfigurator',
  'Admin.ThirdPartyIntegrations.OtherIntegrations',
  'Admin.ThirdPartyIntegrations.Enablement',

  // SAP Cloud Integrations
  'Admin.SAPCloudIntegration.AuthenticationType.Hybrid',
  'Admin.SAPCloudIntegration.AuthenticationType.Basic',
  'Admin.SAPCloudIntegration.AuthenticationType.SamlBearer',
  'Admin.SAPCloudIntegration.AuthenticationType.OAuth',
  'Admin.SAPCloudIntegration.AuthenticationType.Certificate',
  'Admin.SAPCloudIntegration.AuthenticationType.HybridCertificate',

  // Third-Party Integrations
  'xmlThirdPartyIntegrations',
  'Admin.ThirdPartyIntegrations.ESign',
  'Admin.ThirdPartyIntegrations.AdobeSign',
  'Admin.ThirdPartyIntegrations.DocuSign',

  // Federation Settings
  'xmlFederation',
  'Admin.Federation.ServiceProviderSettings',
  'Admin.Federation.DownloadMetadata',
  'Admin.Federation.IdentityProvidersSettings',
  'Admin.Federation.Name',
  'Admin.Federation.NameMsg',
  'Admin.Federation.Metadata',
  'Admin.Federation.IDPMetadataLocationMsg',
  'Admin.Federation.IDPMetadataCertificates',
  'Admin.CertificateManagement.Subject',
  'Admin.Federation.NoMetadataFileCertificatesFound',
  'Admin.Federation.UploadMetadata',
  'Admin.Federation.IgnoreAssertion',
  'Admin.Federation.IgnoreAssertionMsg',
  'Admin.Federation.ArtifactResolveSigned',
  'Admin.Federation.WantPostResponseSignedMsg',
  'Admin.Federation.RequestSigned',
  'Admin.Federation.RequestSignedMsg',
  'Admin.Federation.ResponseSigned',
  'Admin.Federation.ResponseSignedMsg',
  'Admin.Federation.EntityId',
  'Admin.Federation.IDPEntityIdMsg',
  'Admin.Federation.Realm',
  'Admin.Federation.RealmMsg',
  'Admin.Federation.SignOut',
  'Admin.Federation.SignOutMsg',
  'Admin.Federation.PostSignOut',
  'Admin.Federation.PostSignOutMsg',
  'Admin.Federation.Type',
  'Admin.Federation.TypeMsg',
  'Admin.Federation.Description',
  'Admin.Federation.SigningCertificate',
  'Admin.Federation.Certificates',
  'Admin.Federation.EncryptionCertificate',
  'Admin.Federation.Routings',
  'Admin.Federation.RoutingsMsg1',
  'Admin.Federation.RoutingsMsg2',
  'Admin.Federation.NoData',
  'Admin.Federation.Enabled',
  'Admin.Federation.Url',
  'Admin.Federation.SignOnRelayState',
  'Admin.Federation.SignOutRelayState',
  'Admin.Federation.SignInRequestBinding',
  'Admin.Federation.Description',
  'Admin.Federation.SignInRequestBindingMsg',
  'Admin.Federation.SignOutRequestResponseBinding',
  'Admin.Federation.SignOutRequestResponseBindingMsg',
  'Admin.SuccessfullyDeployed',
  'Admin.SuccessfullyUndeployed',
  'Admin.Msg.Deploy',
  'Admin.Msg.Undeploy',
  'Admin.Federation.Mappings',
  'Admin.Federation.MappingsMsg1',
  'Admin.Federation.MappingsMsg2',
  'Admin.Federation.Action',
  'Admin.Federation.Value',
  'Admin.Federation.NameOverride',
  'Admin.Federation.ValueOverride',
  'Admin.Federation.ReadUidFrom',
  'Admin.Federation.ReadUidFromMsg',
  'Admin.Federation.Parameters',
  'Admin.Federation.ParametersMsg1',
  'Admin.Federation.ParametersMsg2',
  'Admin.Federation.ParametersMsg3',
  'Admin.Federation.ParametersMsg4',
  'Admin.Federation.DownloadSpecificSPMetadata',
  'Admin.Federation.ContactSupportForRefresh',
  'Msg.Expired',
  'Admin.FederationDashboard.CertificateCouldNotBeFoundInStore',
  'Admin.FederationDashboard.CertificateIsNotValid',
  'Admin.FederationDashboard.CertificateExpired',
  'Admin.FederationDashboard.CertificateWillExpireSoon',
  'Admin.FederationDashboard.IdentityProviderSignOutNotSupported',
  'xmlRefreshFederation',
  'Admin.Federation.SettingsFromMemmory',
  'Admin.CreateTenantTemplate.LabelTenantName',
  'xsltStatus',
  'Admin.Federation.Diagnostics.SessionId',
  'Admin.ProductAuditTrail_ENTRY_TIME',
  'Admin.Log.Message',
  'Msg.Username',
  'Admin.Federation.Diagnostics.EntityIdList',
  'Admin.Federation.DuplicateParamsName',
  'Admin.Federation.Enabled',
  'Admin.Federation.EnabledInfo',
  'Admin.Federation.DiagnosticsEnabledInfo',
  'Admin.Federation.ServiceProviderName',
  'Admin.Federation.ServiceProviderNameInfo',
  'Admin.Federation.DownloadMetadata',
  'Admin.Federation.MetadataLocationMsg',
  'Admin.Federation.EntityId',
  'Admin.Federation.SpEntityIdInfo',
  'Admin.Federation.Binding',
  'Admin.Federation.BindingInfo',
  'Admin.Federation.SpAuthncontextClassRefMapping',
  'Admin.Federation.SpAuthncontextClassRefMappingInfo',
  'Admin.Federation.WantArtifactResponseSigned',
  'Admin.Federation.WantArtifactResponseSignedInfo',
  'Admin.Federation.WantPostResponseSigned',
  'Admin.Federation.WantPostResponseSignedInfo',
  'Admin.Federation.WantSignOutRequestSigned',
  'Admin.Federation.WantSignOutRequestSignedInfo',
  'Admin.Federation.WantSignOutResponseSigned',
  'Admin.Federation.WantSignOutResponseSignedInfo',
  'Admin.Federation.ConfigurationIsDisabled',
  'Admin.Federation.AdminPage',
  'Admin.Federation.ConfigurationIsEmpty',
  'Admin.Federation.SPFileNameValidation',
  'Admin.Federation.ReadUIDFromInfo',
  // Federation new
  'Admin.Federation.UserIdentifierAttributeSource',
  'Admin.Federation.AdditionalAttributeName',
  'Admin.Federation.LogOut',
  'Admin.Federation.PostLogOutActionType',
  'Admin.Federation.LogOutRedirectionUrl',
  'Admin.Federation.LogInRequestBinding',
  'Admin.Federation.LogOutRequestBindingType',
  'Admin.Federation.WantAuthRequestSigned',
  'Admin.Federation.WantAuthRequestSignedInfo',
  'Admin.Federation.WantAssertionsSigned',
  'Admin.Federation.WantAssertionsSignedInfo',
  'Admin.Federation.IdentityProviderRequestSigned',
  'Admin.Federation.IdentityProviderRequestSignedInfo',
  'Admin.Federation.SignLogOutRequest',
  'Admin.Federation.SignLogOutRequestInfo',
  'Admin.Federation.SignLogOutResponse',
  'Admin.Federation.SignLogOutResponseInfo',
  'Admin.Federation.ValidateIdentityProvider',
  'Admin.Federation.ValidateIdentityProviderInfo',
  'Admin.Federation.UseTrailingSlashInServiceProviderEntityId',
  'Admin.Federation.UseTrailingSlashInServiceProviderEntityIdInfo',
  'Admin.Federation.WantIDPLogOutRequestSigned',
  'Admin.Federation.WantIDPLogOutResponseSigned',
  'Admin.Federation.IDPSigningCertificates',
  'Admin.Federation.IDPSigningCertificateValidityDate',
  'Admin.Federation.WantAuthnRequestsSigned',
  'Admin.Federation.IDPRoutings',
  'Admin.Federation.CreateNewIdpRoute',
  'Admin.Federation.DownloadSapMetadata',
  'Admin.QuoteField.CancelWarningMsg',
  'Admin.QuoteField.CancelWarningTitle',
  'Federation.DynamicSsoRoute',
  'Admin.Federation.EnableLoginButton',
  'Admin.Federation.ManageCertificates',
  'Admin.Federation.Thumbprint',
  'Admin.Federation.EnableLegacyEndpoints',
  'Admin.Federation.EnableLegacyEndpointsInfo',
  'Admin.Federation.ValidateIdentityProviderAssertionValidityDate',
  'Admin.Federation.IdentityProviderAssertionValidityDateClockSkewInMinutes',
  'Admin.Federation.ValidateIdentityProviderAssertionSubjectConfirmation',
  'Admin.Federation.Minutes',

  //SAML Profiles
  'xmlSAMLProfiles',
  'Admin.SAMLProfiles.QuickSearch',
  'Admin.SAMLProfiles.Labels.Actions',
  'Admin.SAMLProfiles.Labels.Name',
  'Admin.SAMLProfiles.DeleteWarningTitle',
  'Admin.SAMLProfiles.DeleteWarningMessage',
  'Admin.SAMLProfile.Name',
  'Admin.SAMLProfile.Credentials',
  'Admin.SAMLProfile.Credentials.InfoMessage',
  'Admin.SAMLProfile.SAMLSigningCertificate',
  'Admin.SAMLProfile.SAMLCertificateValidityDate',
  'Admin.SAMLProfile.Recipient',
  'Admin.SAMLProfile.Audience',
  'Admin.SAMLProfile.NameID',
  'Admin.SAMLProfile.TimeCondition',
  'Admin.SAMLProfile.TimeCondition.InfoMessage',
  'Admin.SAMLProfile.DownloadCertificate',
  'Admin.SAMLProfile.PublicKey',
  'Admin.SAMLProfile.PublicKey.Copied',
  'Admin.SAMLProfile.NameID.Username',
  'Admin.SAMLProfile.NameID.Email',
  'Admin.SAMLProfile.NameID.GlobalUserId',
  'Admin.SAMLProfile.NameID.FederationId',
  'Admin.SAMLProfiles.AssertionAttributes.AddNew',
  'Admin.SAMLProfiles.AssertionAttributes.QuickSearch',
  'Admin.SAMLProfiles.AssertionAttributes.Name',
  'Admin.SAMLProfiles.AssertionAttributes.Value',
  'Admin.SAMLProfiles.AssertionAttributes.FirstName',
  'Admin.SAMLProfiles.AssertionAttributes.LastName',
  'Admin.SAMLProfiles.AssertionAttributes.Username',
  'Admin.SAMLProfiles.AssertionAttributes.Email',
  'Admin.SAMLProfiles.AssertionAttributes.GlobalUserId',
  'Admin.SAMLProfiles.AssertionAttributes.FederationId',
  'Admin.SAMLProfile.Issuer',

  // Webhooks datatable
  'xmlEventSubscriptions',
  'Admin.Webhooks.Url',
  'Admin.Webhooks.EventName',
  'Admin.Webhooks.QuickSearch',
  'Admin.Webhooks.TotalWebhooks',
  'Admin.Webhooks.AddEventSubscription',
  'Admin.Webhooks.Active',

  // Add-edit webhook
  'Admin.Webhooks.IsSubscribtionBilling',
  'Admin.Webhooks.WebhookHttpMethod',
  'Admin.Webhooks.Auth',
  'Admin.Webhooks.AuthenticationHttpMethod',
  'Admin.Webhooks.AuthenticationUrl',
  'Admin.UserGeneral.Username',
  'Admin.UserGeneral.Password',
  'Admin.SAP.SB.ClientId',
  'Admin.SAP.SB.ClientSecret',
  'Admin.Webhooks.QuoteEvent',
  'Admin.Webhooks.GeneralInfoSection',
  'Admin.Webhooks.CustomHeaders',
  'Admin.Webhooks.CustomHeadersKey',
  'Admin.Webhooks.CustomHeadersValue',
  'Admin.Webhooks.AddCustomHeaderEntry',
  'Admin.EventSubscription.CredentialsLocation',
  'Admin.EventSubscription.CredentialLocation.Body',
  'Admin.EventSubscription.CredentialLocation.Header',
  'Admin.EventSubscription.AuthenticationType.Basic',
  'Admin.EventSubscription.AuthenticationType.BasicOAuth',
  'Admin.EventSubscription.AuthenticationType.OAuth',
  'Admin.EventSubscription.AuthenticationType.Certificate',
  'Admin.EventSubscription.AuthenticationType.SamlBearer',
  'Admin.Webhooks.SuccessfullyFetchedAccessToken',
  'Admin.Webhooks.CannotFetchAccessToken',
  'Admin.Webhooks.NotAbleToTestAuthData',
  'Admin.Webhooks.TestAuth',
  'Admin.Webhooks.AuthenticationSection',

  // Erp Provider
  'Admin.ERPProvider.Title',
  'Admin.ErpProvider.Enabled',
  'Admin.Msg.FALSE',
  'Admin.Msg.TRUE',
  'Admin.ERPProvider.SavingSucceeded',
  'Admin.ERPProvider.SavingFailed',
  'Admin.ERPProvider.ErpIntegrationText',

  // Brim Provider
  'Admin.BrimProvider.Title',
  'Admin.BrimProvider.Enabled',
  'Admin.BrimProvider.UsedFixedNumberOfDaysMonthYear',
  'Admin.BrimProvider.Month',
  'Admin.BrimProvider.Year',
  'Admin.BrimProvider.Days',
  'Admin.BrimProvider.LabelDaysToMonthsQuoteCalculations',
  'Admin.BrimProvider.LabelDaysToMonthsQuoteCalculationsTooltip',
  'Admin.BrimProvider.Default',
  'Admin.BrimProvider.Custom',
  'Admin.BrimProvider.AuthenticationMode',
  'Admin.BrimProvider.Username',
  'Admin.BrimProvider.Password',
  'Admin.BrimProvider.ContractHeaderiFlowURL',
  'Admin.BrimProvider.ContractItemiFlowURL',
  'Admin.BrimProvider.CheckAllowableChangesiFlowURL',
  'Admin.BrimProvider.ChangeProcessiFlowURL',
  'Admin.BrimProvider.ChangeProcessGroupiFlowURL',
  'Admin.BrimProvider.BasicAuthentication',
  'Admin.BrimProvider.General',
  'Admin.BrimProvider.Cancellation',
  'Admin.BrimProvider.AddNewCancellation',
  'Admin.BrimProvider.AssetsAndChangeProcess',
  'Admin.BrimProvider.UsageBasedPricingTab',
  'Admin.BrimProvider.UsageBasedPricingTab.SyncStarted',
  'Admin.BrimProvider.UsagePricingSynchronization',
  'Admin.BrimProvider.UsagePricingManualSynchronization',
  'Admin.BrimProvider.SubscriberMappingTableiFlowUrl',
  'Admin.BrimProvider.TableSynchronizationiFlowUrl',
  'Admin.BrimProvider.SubscriberMappingTable',
  'Admin.BrimProvider.MaxChangesNumber',
  'Admin.BrimProvider.SubscriberMappingTableiFlowUrlHint',
  'Admin.BrimProvider.EnableSynchronization',
  'Admin.BrimProvider.UsagePricing.DailyScheduler',
  'Admin.BrimProvider.UsageBPricing.TableId',
  'Admin.BrimProvider.UsagePricingSynchronize',
  'Admin.BrimProvider.EditCancellation',
  'Admin.BrimProvider.Description',
  'Admin.BrimProvider.CancellingParty',
  'Admin.BrimProvider.CancellationReason',
  'Admin.BrimProvider.CancellationProcedure',
  'Admin.BrimProvider.CancellationInformation',
  'Admin.BrimProvider.TranslateCancellationDescription',
  'Admin.BrimProvider.Label',
  'Admin.BrimProvider.MaxLengthWarning',
  'Admin.BrimProvider.QuickSearch',
  'Admin.BrimProvider.TotalCancellations',
  'Admin.BrimProvider.PartnerFunction',
  'Admin.BrimProvider.AssetsChangeProcesses',
  'Msg.AdvancedSearch',
  'UserCustomFields.Translation.DefaultLanguage',
  'Admin.SelectLanguage',
  'Admin.BrimProvider.CertificateAuthentication',
  'Admin.BrimProvider.SelectCertificate',
  'Admin.BrimProvider.CopyAssetsToggleLabel',
  'Admin.BrimProvider.CopyAssetsToggleInfo',

  // CX AI
  'Admin.CxAiProvider.Title',
  'Admin.CxAiProvider.GeneralSettings',
  'Admin.CxAiProvider.DataIngestionMappings',
  'Admin.CxAiProvider.DataInferenceMappings',
  'Admin.CxAiProvider.DataInferenceQuoteMappingsLabel',
  'Admin.CxAiProvider.DataInferenceQuoteMappingsLabelInfo',
  'Admin.CxAiProvider.DataInferenceProductMappingsLabel',
  'Admin.CxAiProvider.DataInferenceProductMappingsLabelInfo',
  'Admin.Cxai.FilterByNameOrValue',
  'Admin.CxAiProvider.DataInferenceName',
  'Admin.CxAiProvider.DataInferenceValue',
  'Admin.CxAiProvider.DataInferenceCustomValue',
  'Admin.CxAiProvider.DataInferenceCustomValueInfo',
  'Admin.CxAiProvider.DataInferenceMappingType',
  'Admin.CxAiProvider.DataInferenceMappingTypeInfo',
  'Admin.Cxai.FilterByNameOrValue',
  'Admin.Cxai.StandardMapping',
  'Admin.Cxai.StandardValue',
  'Admin.CxAiProvider.AuthUrl',
  'Admin.CxAiProvider.EnableCxAi',
  'Admin.CxAiProvider.BaseUrl',
  'Admin.CxAiProvider.ClientId',
  'Admin.CxAiProvider.ClientSecret',
  'Admin.CxAiProvider.SupportedScenarios',
  'Admin.CxAiProvider.AiUseCase',
  'Admin.CxAiProvider.EnableScenario',
  'Admin.CxAiProvider.EnableScoring',
  'Admin.CxAiProvider.TrainingStatus',
  'Admin.CxAiProvider.CrossSell',
  'Admin.CxAiProvider.Pricing',
  'Admin.CxAiProvider.ModelTrainOFFMessage',
  'Admin.CxAiProvider.ModelTrainONMessage',
  'Admin.CxAiProvider.Status',
  'Admin.CxAiProvider.StartTime',
  'Admin.CxAiProvider.RunId',
  'Admin.CxAiProvider.StatusCode',
  'Admin.CxAiProvider.QuoteStatuses',
  'Admin.CxAiProvider.QuoteItemTable',
  'Admin.CxAiProvider.Name',
  'Admin.CxAiProvider.Value',
  'Admin.CxAiProvider.CustomValue',
  'Admin.CxAiProvider.Description',
  'Admin.CxAiProvider.TrainingSuccess',
  'Admin.CxAiProvider.TrainingFailure',
  'Admin.CxAiProvider.TrainingPending',
  'Admin.CxAiProvider.TrainingConflict',
  'Admin.CxAiProvider.TrainingOther',
  'Admin.CxAiProvider.CxAiUnAvailable',
  'Admin.CxAiProvider.SupportedScenarioLabelInfo',
  'Admin.CxAiProvider.DataIngestionQuoteMappingsLabelInfo',
  'Admin.CxAiProvider.QuoteStatusesLabelInfo',
  'Admin.CxAiProvider.PromotionsFeatureEnabledError',

  // General attribute mappings
  'Admin.SAPAttributesMappings',
  'Admin.SAPAttributesMappings.Edit',
  'Admin.CPSProvider.GlobalAttributes',
  'Admin.CPSProvider.GlobalAttributes.SAPCountryCode',
  'Admin.CPSProvider.GlobalAttributes.SAPCountryCodeInfo',
  'Admin.CPSProvider.GlobalAttributes.Division',
  'Admin.CPSProvider.GlobalAttributes.DivisionInfo',
  'Admin.CPSProvider.PricingDuringConfiguration',
  'Admin.CPSProvider.BasePricingConditionName',
  'Admin.CPSProvider.BasePricingConditionNameInfo',
  'Admin.CPSProvider.Standalone.GlobalAttributes.VariantConditionPricingName',
  'Admin.CPSProvider.Standalone.GlobalAttributes.CurrencyCode',
  'Admin.CPSProvider.ServiceProfileConditionName',
  'Admin.CPSProvider.ResponseProfileConditionName',
  'Admin.CPSProvider.ServiceProfileConditionNameInfo',
  'Admin.CPSProvider.ResponseProfileConditionNameInfo',
  'Admin.CPSProvider.VariantConditionPricingNameInfo',
  'Admin.CPSProvider.AutoReconfigureOnCPSPricingChanged',
  'Admin.CPSProvider.AutoreconfigureOnCPSPricingChangedInfo',
  'Admin.CPSProvider.PricingAttributeValueSeparator',
  'Admin.CPSProvider.PricingAttributeValueSeparatorInfo',
  'Admin.CPSProvider.PricingAttributes',
  'Admin.CPSProvider.ReferenceCharacteristics',
  'Admin.CPSProvider.NewPricingAttribute',
  'Admin.CPSProvider.NewPricingDate',
  'Admin.CPSProvider.PricingAttributes.QuickSearch',
  'Admin.CPSProvider.PricingAttributes.Total',
  'Admin.CPSProvider.Name',
  'Admin.CPSProvider.Formula',
  'Admin.CPSProvider.FormulaTooltip',
  'Admin.CPSProvider.EvaluatePerItem',
  'Admin.CPSProvider.EvaluatePerItemTooltip',
  'Admin.CPSProvider.Multivalued',
  'Admin.CPSProvider.MultivaluedTooltip',
  'Admin.CPSProvider.NewReferenceCharacteristic',
  'Admin.CPSProvider.ReferenceCharacteristics.QuickSearch',
  'Admin.CPSProvider.ReferenceCharacteristics.Total',
  'Admin.CPSProvider.Standalone.Enable',
  'Admin.CPSProvider.WithQuote',
  'Admin.CPSProvider.NoQuote',
  'Admin.CPSProvider.IsCPSDocumentPricingUsed',
  'Admin.CPSProvider.IsCPSDocumentPricingUsedInfo',
  'Admin.CPSProvider.SourceOfPricingDetails.ConditionFunction',
  'Admin.CPSProvider.SourceOfPricingDetails.ConditionType',
  'Admin.CPSProvider.SourceOfPricingDetails',
  'Admin.CPSProvider.SourceOfPricingDetailsInfo',
  'Admin.CPSProvider.ConditionType.AddNew',
  'Admin.CPSProvider.ConditionType.NotUnique',
  'Admin.CPSProvider.ConditionType.NotValid',
  'Admin.CPSProvider.BasePriceDeterminationMethod',
  'Admin.CPSProvider.BasePriceDeterminationMethodInfo',
  'Admin.CPSProvider.ExchangeRateType',
  'Admin.CPSProvider.ItemLevelPricingDate',
  'Admin.CPSProvider.ItemLevelPricingDateHint',
  'Admin.CPSProvider.ItemLevelServiceDate',
  'Admin.CPSProvider.ItemLevelServiceDateHint',
  'Admin.CPSProvider.ItemSpecificSection',

  // Events for pricing attributes
  'Admin.CPSProvider.PricingAttributesEvents',
  'Admin.CPSProvider.PricingAttributesEventsDialog.Title',
  'Admin.CPSProvider.PricingAttributesEvents.AvailableFieldsOrPartnerFunctions',
  'Admin.CPSProvider.PricingAttributesEvents.SelectedFieldsOrPartnerFunctions',
  'Admin.CPSProvider.PricingAttributesEvents.EmptyList',
  'Admin.CPSProvider.PricingAttributesEvents.InfoMessage.SalesAreaEnabled',
  'Admin.CPSProvider.PricingAttributesEvents.InfoMessage.SalesAreaDisabled',
  'Admin.CPSProvider.PricingAttributesEvents.PartnerFunctions',
  'Admin.CPSProvider.PricingAttributesEvents.QuoteCustomFields',
  'Admin.CPSProvider.PricingAttributesEvents.QuoteItemCustomFields',
  'Admin.CPSProvider.PricingAttributesEvents.Search',

  // Certificate
  'Admin.CertificateManagement.FindByNameOrSoapUrl',
  'Admin.CertificateManagement.SelectCertificate',
  'Admin.CertificateManagement.CertificateRequired',
  'Admin.CertificateManagement.TotalCertificates',
  'Admin.CertificateManagement.Issuer',
  'Admin.CertificateManagement.ValidFrom',
  'Admin.CertificateManagement.ValidTo',
  'Admin.CertificateManagement.Purpose',
  'Admin.CertificateManagement.SoapUrl',
  'Admin.CertificateManagement.Thumbprint',
  'Admin.Dkim.Active',

  // External Configuration
  'Admin.Providers.ExternalConfiguration',
  'Admin.Providers.ExternalConfiguration.Events.Title',
  'Admin.Providers.ExternalConfiguration.Enabled',
  'Admin.Providers.ExternalConfiguration.GlobalScript',
  'Admin.Providers.ExternalConfiguration.OnConfigure',
  'Admin.Providers.ExternalConfiguration.OnAddToQuote',
  'Admin.Providers.ExternalConfiguration.OnDeleteItem',
  'Admin.Providers.ExternalConfiguration.OnCopyItem',
  'Admin.Providers.ExternalConfiguration.OnReconfigure',
  'Admin.Providers.ExternalConfiguration.OnConfigure.Info',
  'Admin.Providers.ExternalConfiguration.OnAddToQuote.Info',
  'Admin.Providers.ExternalConfiguration.OnDeleteItem.Info',
  'Admin.Providers.ExternalConfiguration.OnCopyItem.Info',
  'Admin.Providers.ExternalConfiguration.OnReconfigure.Info',
  'Admin.Providers.ExternalConfiguration.Attach',
  'Admin.Providers.ExternalConfiguration.Detach',
  'Admin.Providers.ExternalConfiguration.AddNewGlobalScript',
  'Admin.Msg.CancelButton',
  'Admin.Msg.Save',
  'Admin.Msg.Back',
  'Script.UniqueScriptName',
  'Script.UniqueScriptName.Dialog.Title',

  // CPS Provider
  'Admin.CPSProvider.Title',
  'Admin.CPSProvider.Enabled',
  'Admin.CPSProvider.GeneralSettings',
  'Admin.CPSProvider.ApplyRecommendedSettings',
  'Admin.CPSProvider.ApplyRecommendedSettings.InfoMessage',
  'Admin.CPSProvider.EnableVariantConfigurationCallsOnDemand',
  'Admin.CPSProvider.EnableVariantConfigurationCallsOnDemandHint',
  'Admin.CPSProvider.EnableVariantPricingCallsOnDemand',
  'Admin.CPSProvider.EnableVariantPricingCallsOnDemandHint',
  'Admin.CPSProvider.ShouldFetchPossibleValuesPerTab',
  'Admin.CPSProvider.ShouldFetchPossibleValuesPerTabHint',
  'Admin.CPSProvider.DoNotCheckStatisticalFlag',
  'Admin.CPSProvider.DoNotCheckStatisticalFlagHint',
  'Admin.CPSProvider.AlwaysGetPricingResponse',
  'Admin.CPSProvider.AlwaysGetPricingResponseHint',
  'Admin.CPSProvider.AuthenticationSettings',
  'Admin.CPSProvider.AuthenticationURL',
  'Admin.CPSProvider.PricingClientId',
  'Admin.CPSProvider.PricingClientSecret',
  'Admin.CPSProvider.TestAuthenticationSettings',
  'Admin.CPSProvider.ConfigurationAuthenticationSucceded',
  'Admin.CPSProvider.ConfigurationAuthenticationFailed',
  'Admin.CPSProvider.PricingAuthenticationSucceded',
  'Admin.CPSProvider.PricingAuthenticationFailed',
  'Admin.CPSProvider.BaseURLs',
  'Admin.CPSProvider.BaseConfigUrlWarning',
  'Admin.CPSProvider.BaseConfigURL',
  'Admin.CPSProvider.BasePricingURL',
  'Admin.CPSProvider.KBSyncSettings',
  'Admin.CPSProvider.EnableDailyKBSync',
  'Admin.CPSProvider.EnableDailyKBSyncHint',
  'Admin.CPSProvider.DailyScheduler',
  'Admin.CPSProvider.NotificationMails',
  'Admin.CPSProvider.NotificationMailsInfo',
  'Admin.CPSProvider.TranslationSettings.Title',
  'Admin.CPSProvider.KBSyncLanguage',
  'Admin.CPSProvider.KBSyncLanguageInfo',
  'Admin.CPSProvider.SyncLanguagesHistorically',
  'Admin.CPSProvider.SyncLanguagesHistoricallyInfo',
  'Admin.CPSProvider.LayoutSettings.Title',
  'Admin.CPSProvider.AlwaysUseProductLayoutFromVC',
  'Admin.CPSProvider.AlwaysUseProductLayoutFromVCInfo',
  'Admin.CPSProvider.AlwaysDetermineProductAttributeDisplayTypeFromVC',
  'Admin.CPSProvider.AlwaysDetermineProductAttributeDisplayTypeFromVCInfo',
  'Admin.CPSProvider.AlwaysDetermineProductConfigTypeFromVC',
  'Admin.CPSProvider.AlwaysDetermineProductConfigTypeFromVCInfo',
  'Admin.CPSProvider.Dialog.Title',
  'Admin.CPSProvider.Dialog.Message',

    // Docu Sign Provider
    'Admin.DocuSignProvider.Title',
    'Admin.DocuSignProvider.Enabled',
    'Admin.DocuSignProvider.AuthenticationSettings',
    'Admin.DocuSignProvider.AuthenticationSettings.AlertInfo',
    'Admin.DocuSignProvider.EmailSettings',
    'Admin.DocuSignProvider.DocuSignBaseAuthenticationUrl',
    'Admin.DocuSignProvider.DocuSignBaseAuthenticationUrlHint',
    'Admin.DocuSignProvider.DocuSignUserID',
    'Admin.DocuSignProvider.DocuSignUserIDHint',
    'Admin.DocuSignProvider.DocuSignIntegrationKey',
    'Admin.DocuSignProvider.DocuSignIntegrationKeyHint',
    'Admin.DocuSignProvider.DocuSignLoginUrl',
    'Admin.DocuSignProvider.DocuSignPrivateKey',
    'Admin.DocuSignProvider.DocuSignPrivateKeyHint',
    'Admin.DocuSignProvider.DocuSignConsent',
    'Admin.DocuSignProvider.SetAdminAccount',
    'Admin.DocuSignProvider.TestAuthenticationSettings',
    'Admin.DocuSignProvider.EnvironmentUrl',
    'Admin.DocuSignProvider.TestAuthenticationSettings.SuccessMessage',
    'Admin.DocuSignProvider.DefaultEmailSubject',
    'Admin.DocuSignProvider.DefaultEmailBody',
    'Admin.DocuSignProvider.CounterSignerSubject',
    'Admin.DocuSignProvider.CounterSignerBody',
    'DocuSign.CounterSigners',
    'Admin.DocuSignProvider.Countersigners.Actions',
    'Admin.DocuSignProvider.Countersigners.Name',
    'Admin.DocuSignProvider.Countersigners.Email',
    'Admin.DocuSignProvider.Countersigners.Position',
    'Admin.DocuSignProvider.Countersigners.Company',
    'Admin.DocuSignProvider.Countersigners.QuickSearch',
    'Admin.DocuSignProvider.Countersigners.AddNew',
    'Admin.DocuSignProvider.Countersigners.SelectUser',
    'Admin.DocuSignProvider.Countersigners.Select',
    'Admin.DocuSignProvider.Countersigners.AddSelected',
    'Admin.DocuSignProvider.Countersigners.AddUser',
    'Admin.DocuSignProvider.DocuSignHMACKey',
    'Admin.DocuSignProvider.DocuSignHMACKeyHint',

  //Adobe Sign Provider
  'Admin.AdobeSignProvider.Title',
  'Admin.AdobeSignProvider.IntegrationTurnedOn',
  'Admin.AdobeSignProvider.AdobeSignBaseUrl',
  'Admin.AdobeSignProvider.AdobeSignBaseUrlHint',
  'Admin.AdobeSignProvider.AdobeSignClientId',
  'Admin.AdobeSignProvider.AdobeSignClientIdHint',
  'Admin.AdobeSignProvider.AdobeSignClientSecret',
  'Admin.AdobeSignProvider.AdobeSignClientSecretHint',
  'Admin.AdobeSignProvider.OAuthUrl',
  'Admin.AdobeSignProvider.OAuthUrlHint',
  'Admin.AdobeSignProvider.UseAdminMode',
  'Admin.AdobeSignProvider.UseAdminModeHint',
  'Admin.AdobeSignProvider.ImpersonateEmail',
  'Admin.AdobeSignProvider.ImpersonateEmailHint',
  'AdobeSign.SetAdminAccount',
  'AdobeSign.ResetAdminAccount',
  'Admin.AdobeSignProvider.ResetAdminAccountInfoMessage',
  'Admin.AdobeSignProvider.TestAuthenticationSettings',

  //Cloud Integration
  'Admin.CloudIntegration.Title',
  'Admin.CloudIntegration.Enabled',
  'Admin.CloudIntegration.AuthenticationDetails',
  'Admin.CloudIntegration.GeneralSettings',
  'Admin.CloudIntegration.Endpoints',
  'Admin.CloudIntegration.AuthenticationType',
  'Admin.CloudIntegration.Username',
  'Admin.CloudIntegration.Password',
  'Admin.CloudIntegration.AuthenticationURL',
  'Admin.CloudIntegration.ClientId',
  'Admin.CloudIntegration.ClientSecret',
  'Admin.CloudIntegration.SelectCertificate',
  'Admin.CloudIntegration.SendCustomers',
  'Admin.CloudIntegration.TimeZone',
  'Admin.CloudIntegration.TimeZoneHint',
  'Admin.CloudIntegration.BaseUrl',
  'Admin.CloudIntegration.FetchDataEndpoint',
  'Admin.CloudIntegration.PostDataEndpoint',
  'Admin.CloudIntegration.PostQuoteEndpoint',
  'Admin.CloudIntegration.PlaceOrderEndpoint',
  'Admin.CloudIntegration.SamlProfile',
  'Admin.CloudIntegration.TransactionIdLabel',
  'Admin.CloudIntegration.TransactionIdLabelInfo',
  'Admin.CloudIntegration.TranslateTransactionIdLabel',
  'Actions.TranslateTransactionIdLabel.SaveTransactionIdLabelFirst',
  'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Title',
  'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Column.Label',
  'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Column.DefaultLanguage',
  'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Column.SelectLanguage',
  'Admin.CloudIntegration.ClientCertificate',

  //C4C Obsolete
  'Admin.C4CObsolete.Title',
  'Admin.C4CObsolete.FetchOpporutinityDetailsForNewQuoteEndpoint',
  'Admin.C4CObsolete.FetchOpporutinityDetailsForExistingQuoteEndpoint',
  'Admin.C4CObsolete.UpdateOpportunityEndpoint',
  'Admin.C4CObsolete.PostSalesQuoteEndpoint',
  'Admin.C4CObsolete.UpdateOpportunityAndSalesQuoteEndpoint',
  'Admin.C4CObsolete.PostDocumentToOpportunityAndSalesQuoteEndpoint',
  'Admin.C4CObsolete.PostDocumentToOpportunityEndpoint',
  'Admin.C4CObsolete.PostDocumentToSalesQuoteEndpoint',

  //C4C
  'Admin.C4C.Title',
  'Admin.C4C.Enabled',
  'Admin.C4C.LandingUrl',
  'C4C.FederationNotConfigured',
  'Admin.C4C.FetchSalesQuoteDetailsEndpoint',
  'Admin.C4C.UpdateSalesQuoteEndpoint',
  'Admin.C4C.ShouldUpdateSalesQuoteOnSave',

  //Commerce Cloud
  'Admin.CommerceCloud.Title',
  'Admin.CommerceCloud.Enabled',
  'Admin.SAP.HCPIS.CommerceIntegrationText',
  'Admin.CommerceCloud.CommerceNotification',
  'Admin.CommerceCloud.CommerceRevisionNotification',
  'Admin.CommerceCloud.ReleaseQuoteEndpoint',
  'Admin.CommerceCloud.ReleaseQuoteAndProposalEndpoint',

  //SAP Companion
  'Admin.Companion.Title',
  'Admin.EnableSapCompanion.ToggleTitle',
  'Admin.SapCompanion.ConfigurationUrl',
  'Admin.Companion.InvalidUrl',

  // Solution Order
  'Admin.SAPIntegrations.SolutionOrderProvider',
  'Admin.SolutionOrderProvider.Title',
  'Admin.SolutionOrderProvider.Enable',
  'Admin.SolutionOrderProvider.Authentication',
  'Admin.SolutionOrderProvider.S4BaseUrl',
  'Admin.SolutionOrderProvider.S4BaseUrlInfo',
  'Admin.SolutionOrderProvider.AuthenticationType',
  'Admin.SolutionOrderProvider.Username',
  'Admin.SolutionOrderProvider.Password',
  'Admin.SolutionOrderProvider.SelectCertificate',
  'Admin.SolutionOrderProvider.AuthenticationType.Basic',
  'Admin.SolutionOrderProvider.AuthenticationType.Certificate',
  'Admin.SolutionOrderProvider.FieldMappings.Formula',
  'Admin.SolutionOrderProvider.TestConnection',
  'Admin.SolutionOrderProvider.FieldMapping',
  'Admin.SolutionOrderProvider.FieldMappings.NewFieldMapping',
  'Admin.SolutionOrderProvider.FieldMappings.FormulaTooltip',
  'Admin.SolutionOrderProvider.FieldMappings.EvaluatePerItem',
  'Admin.SolutionOrderProvider.FieldMappings.EvaluatePerItemTooltip',
  'Admin.SolutionOrderProvider.FieldMappings.FieldType',
  'Admin.SolutionOrderProvider.FieldMappings.Name',
  'Admin.SolutionOrderProvider.FieldMappings.InvalidName',
  'Admin.SolutionOrderProvider.FieldMappings.DuplicateName',
  'Admin.SolutionOrderProvider.FieldMappings.QuickSearch',
  'Admin.SolutionOrderProvider.FieldMappings.Total'
]
